import { Box } from '@mui/material';
import React from 'react';
import { CustomDataGrid } from './CustomDataGrid';


const NonPaginatedDataGrid = ({ columns, rows, columnVisibilityModel = {
  id: false,
  data_shared_on: false,
  pack: false,
  "condition_/_stage": false,
  other_test: false,
  _id: false
}, ...otherProps
}) => {
  // const columns = Object.keys(array[0]).map((item) => ({
  //   field: item,
  //   width: 200,
  //   headerName: item?.split("_").join(" ").toUpperCase()
  // }));
  // console.log(columns);
  return (
    <Box sx={{
      width: "100%"
    }}>
      <CustomDataGrid
        slots={{
          // toolbar: GridToolbar
        }}
        columns={columns}
        rows={rows}
        // pagination
        // initialState={{ pagination: { paginationModel: { pageSize: 10 } } }}
        // pageSizeOptions={[10, 25, 50, 100]}
        hideFooter
        columnVisibilityModel={columnVisibilityModel}
        sx={{
          maxHeight: "550px",
          minHeight: "500px"
        }}
        {...otherProps}
      />
    </Box>
  );
};

export default NonPaginatedDataGrid;